const React = require('react')

module.exports = { 
      attributes: {"ogImage":"img/npt_metamobile.svg"},
    
      react: 
      function (props) {
        Object.keys(props).forEach(function (key) {
          this[key] = props[key]
        })
        const markdown = /*#__PURE__*/React.createElement("div", {
  className: "frontmatter-markdown"
});
        return markdown
      }
    ,
     }